import _map from 'lodash/map'

export const _parseToIdArray = objectArray =>
  _map(objectArray, object => object.value)
